import Http from '../../http';
import { FETCH_SUBSCRIPTION_PLANS } from '../constants';

export const fetchAllSubscriptionPlans = () => dispatch =>
  Http.get('/subscription/plan').then(plans => dispatch({
    type: FETCH_SUBSCRIPTION_PLANS,
    payload: plans,
  }));


export const createSubscriptionPlan = data => dispatch =>
  Http.post('/subscription/plan', data).then(() => dispatch(fetchAllSubscriptionPlans()));

export const modifySubscriptionPlan = (id, data) => dispatch =>
  Http.put(`/subscription/plan/${id}`, data).then(() => dispatch(fetchAllSubscriptionPlans()));

export const deleteSubscriptionPlan = id => dispatch =>
  Http.delete(`/subscription/plan/${id}`).then(() => dispatch(fetchAllSubscriptionPlans()));
